function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Checkmark_Little",
  className: "all",
  d: "M1.397 9.781l5.577 7.617 11.716-16",
  fill: "none",
  stroke: "#00a851",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2
});

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.089,
    height: 18.397,
    viewBox: "0 0 20.089 18.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMC4wODkiIGhlaWdodD0iMTguMzk3IiB2aWV3Qm94PSIwIDAgMjAuMDg5IDE4LjM5NyI+CiAgPHBhdGggaWQ9IkNoZWNrbWFya19MaXR0bGUiIGNsYXNzPSJhbGwiIGQ9Ik0xMjE3LjM2MSw1NS44NzRsNS41NzcsNy42MTcsMTEuNzE2LTE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIxNS45NjQgLTQ2LjA5MykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwYTg1MSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };